"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Patient_MyPatient = void 0;
class Patient_MyPatient {
    constructor(props) {
        this.dni = props?.dni || null;
        this.email = props?.email || null;
        this.fullname = props?.fullname || null;
        this.location = props?.location || null;
        this.n_afiliado = props?.n_afiliado || null;
        this.notes = props?.notes || null;
        this.obra_social = props?.obra_social || null;
        this.plan_afiliado = props?.plan_afiliado || null;
        this.uid = props?.uid || null;
        this.ws = props?.ws || null;
    }
}
exports.Patient_MyPatient = Patient_MyPatient;
